import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';
import { EBetslipBetType, EBetslipType } from 'interfaces/betslip';
import { getQuickBetEnabled } from 'store/selectors/betslip/features';

const getBetSlip = getSelectorRoot('betSlip');

const getType = getBetSlip('type');
const getTabs = getBetSlip('tabs');
const getTaxes = getBetSlip('taxes');
const getMustOpen = getBetSlip('mustOpen');
const getMustClose = getBetSlip('mustClose');
const getBetslipType = getBetSlip('betslipType');
const getBetslipOpen = getBetSlip('betslipOpen');
const getLadderLoaded = getBetSlip('ladderLoaded');
const getActiveTabPage = getBetSlip('activeTabPage');
const getFreezeTabChange = getBetSlip('freezeTabChange');
const getAdvancedSelectedTab = getBetSlip('advancedSelectedTab');
const getQuickSingleBetslipOpen = getBetSlip('singleQuickBetslipOpen');
const getIsBetslipOpenedInDefaultMode = createSelector(
  [getQuickBetEnabled, getBetslipOpen],
  (quickBetEnabled, isBetslipOpened) => !quickBetEnabled && isBetslipOpened
);

const getComputedBetType = createSelector(
  [getType, getBetslipType],
  (betType, betslipType) =>
    betslipType === EBetslipType.ADVANCED
      ? EBetslipBetType.SINGLE
      : (betType as EBetslipBetType)
);

export {
  getType,
  getTabs,
  getTaxes,
  getMustOpen,
  getMustClose,
  getBetslipType,
  getBetslipOpen,
  getLadderLoaded,
  getActiveTabPage,
  getFreezeTabChange,
  getComputedBetType,
  getAdvancedSelectedTab,
  getQuickSingleBetslipOpen,
  getIsBetslipOpenedInDefaultMode
};
